<template lang="pug">
  .pevents--item
    .row.no-gutters.align-items-center
      .col-6.col-xl-8.col-md-6.col-sm-8
        .row.no-gutters.align-items-center
          .col-sm-7.col-md-12.col-xl-7.order-sm-2.order-md-1.order-xl-2
            small: strong.text-uppercase {{ item.announcementType }}
            template(v-if="item.announcementType === 'Cash Dividend' || item.announcementType === 'Special Dividend'")
              .pad_t--5
                small <strong>Ex-Date:</strong> {{ item.exDate }}
              .pad_t--5
                small <strong>Amount:</strong> {{ item.amountCurrency }} {{ item.amountValue }} {{ item.amountUnit }}

          .col-sm-5.col-md-12.col-xl-5.order-sm-1.order-md-2.order-xl-1.pad_t--10-lg
            CounterDropdown(:counterCode="item.counterCode", :counterName="item.counterName")

      .col-6.col-xl-4.col-md-6.col-sm-4
        .align__center
          small: strong.text-uppercase Morningstar Rating
          .pt-1
            template(v-for="index in Number(item.counterDto.data[0].attributes.morningStarRating[0].QuantitativeStarRating)")
              Star

</template>


<script>
import Star from './Star';
import CounterDropdown from './CounterDropdown';

export default {
  name: 'EventsInfo',

  components: {
    CounterDropdown,
    Star
  },

  props: {
    item: Object
  },
}
</script>